import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Splash } from "../components/Splash";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    completeGoogle(decodeURIComponent(match[1]))
      .then((user) => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "admin" ? "/reef" : "/portal", { replace: true });
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      });
  }, [completeGoogle, navigate]);

  return <Splash text="Signing you in…" />;
}
